// 고객 대화 링크 액션(rpc, legacy modules/message/share-actions) — 고객 글쓰기·사진·고치기·지우기·읽음 옮기기 · 토큰은 input.token(사진은 첫 인자).
import { shareRpc } from "@/api/client";

export const postCustomerMessageByLink = (input: { token: string; body: string }) =>
  shareRpc("c", input.token, "postCustomerMessageByLink", input);

export const postCustomerMessagePhotoByLink = (token: string, form: FormData) =>
  shareRpc("c", token, "postCustomerMessagePhotoByLink", token, form);

export const editCustomerMessageByLink = (input: { token: string; message_id: string; body: string; seen_edited_at: string | null }) =>
  shareRpc("c", input.token, "editCustomerMessageByLink", input);

export const deleteCustomerMessageByLink = (input: { token: string; message_id: string; seen_edited_at: string | null }) =>
  shareRpc("c", input.token, "deleteCustomerMessageByLink", input);

export const markCustomerMessagesSeen = (input: { token: string; seen_until: string }) =>
  shareRpc("c", input.token, "markCustomerMessagesSeen", input);
